import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

export default function NotFound() {
    const { lang, t } = useLang();
    return (
        <div data-testid="not-found-page" className="marble-bg min-h-screen pt-40 pb-24 text-center">
            <p className="font-display text-8xl gold-text">404</p>
            <h1 className="mt-4 font-display text-2xl text-amber-50">{t.common.notFoundTitle}</h1>
            <p className="mt-2 text-sm text-stone-400">{t.common.notFoundSub}</p>
            <Link to="/" data-testid="not-found-home-link" className="mt-8 inline-block text-xs uppercase tracking-[0.18em] text-amber-300 underline underline-offset-4">
                {t.payment.backHome}
            </Link>
        </div>
    );
}
